import { usePositionsDrawerPositionsTab } from "#/store/app/positionsDrawer/positionsDrawerPositionsTab";

import { Contents } from "../Contents/Contents";
import { AllPositions } from "./components/AllPositions/AllPositions";
import { OptionPositions } from "./components/OptionPositions/OptionPositions";
import { PerpPositions } from "./components/PerpPositions/PerpPositions";

export interface PositionsProps {
  isPortfolioVariant?: boolean;
}

export const Positions: React.FC<PositionsProps> = ({ isPortfolioVariant }) => {
  const { positionsDrawerPositionsTab } = usePositionsDrawerPositionsTab();

  return (
    <Contents isEmpty={false} animateKey={positionsDrawerPositionsTab}>
      {positionsDrawerPositionsTab === "all" && (
        <AllPositions isPortfolioVariant={isPortfolioVariant} />
      )}
      {positionsDrawerPositionsTab === "options" && (
        <OptionPositions isPortfolioVariant={isPortfolioVariant} />
      )}
      {positionsDrawerPositionsTab === "perps" && (
        <PerpPositions isPortfolioVariant={isPortfolioVariant} />
      )}
    </Contents>
  );
};
